export default __webpack_public_path__ + "static/media/29.2122ca84.png";